/** Editorial section divider — thin oak hairlines with a small diamond. */
export const Ornament = () => (
  <div className="ornament" aria-hidden="true">
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <rect x="5" y="0.5" width="6" height="6" transform="rotate(45 5 0.5)" stroke="currentColor" strokeWidth="0.8" />
    </svg>
  </div>
);
